import { createAction } from 'redux-actions';
import types from './types';

export const setWallets = createAction(types.SET_WALLETS);
export const updateWalletBalance = createAction(types.UPDATE_WALLET_BALANCE);
